module.exports = __webpack_public_path__ + "img/SOKAL-WEB-112822-CreativeAnalysis-GMC-LIfestyle.33cc4bc3.jpeg";